// extracted by mini-css-extract-plugin
module.exports = {"main":"LoginHeader_main__3-uuC","background":"LoginHeader_background__BG6lj"};